import { CONTACT_EMAIL, PUBLISHER_NFT } from '../../constants'

export const baseEnglishTexts = {
  communitiesShapeWorldtTroughEducation:
    'Communities shaping the world through education',
  openCampus: 'Open Campus',
  protocol: 'Protocol',
  allowlist: 'Allowlist',
  wallet: 'Wallet',
  meetTheBuilders: 'Meet the Builders',
  theEduProtocol: 'About the Protocol',
  theEduProtocolDescription:
    'Open Campus utilizes a new protocol allowing communities to create, own, and promote content they want to see in the world and enables educators to earn revenue and gain recognition for their contributions.',
  ecosystem: 'Protocol Ecosystem',
  ecosystemDescription:
    '<bold>Communities<bold> can utilize blockchain technology to fund, co-own and learn from educational content that fits their needs.\n\n<bold>Creators<bold> launch their content on the protocol by offering promotional rights through Publisher NFTs, where co-publishers can earn revenue based on their contributions.\n\n<bold>Philanthropists<bold> can support educational causes directly and track their donation on-chain through Smart Donations.',
  interoperability: 'Interoperability',
  interoperabilityDescription:
    'Powered by one token, supported wherever and whenever learning happens.',
  tinytapDescriptionList: [
    'Top 10 Kids App Worldwide',
    'Proven Leader in UGC Education',
    '250k+ Interactive Lessons',
    '100k+ Creators',
  ],
  tinytapDescription: `A no-code authoring platform for gamified interactive lessons, courses, and full curriculums, with a community of thousands of creators, and millions of families. TinyTap adopted the Open Campus protocol pioneering the first-ever content ownership on blockchain, the ${PUBLISHER_NFT}, establishing direct revenue from families to creators.`,
  publisherNfts: 'TinyTap’s Publisher NFT',
  publisherNftsDescription:
    'This model promotes Co-Publishing Rights between Creators and Marketers. 12 sold for over 200Ξ at TinyTap’s Genesis auction in 2022!',
  findOutMoreOn: 'Find out more on',
  mocaverseDescription:
    'The flagship NFT Project from Animoca Brands that brings the world closer together through building, creating, playing, and learning. The Mocaverse ‘Learn Realm’ is an idea exchange for learning Web3 insights where Open Campus will be activated as the first partner.',
  gemsDescription:
    'The largest school network in the MENA region with 130k+ students throughout 60+ schools. Open Campus will co-create and launch new Arabic curriculums together with GEMS Education, and the content will be tokenized as Publisher NFTs.',
  buildTheCampus: 'Build the Campus',
  buildTheCampusDescription: `As an Open platform we invite communities to participate and build the future of education.\n\nWant to see your content entity on the Open Campus?\n`,
  emailUs: `Email us`,
  launchPartners: 'Launch Partners',
  communityCenter: 'Community Center',
  communityCenterDescription:
    'Connect and meet the other\neducation enthusiasts!\n\nFollow us on Twitter for\nthe latest announcements.\n\nJoin the Discord to chat\nwith Open Campus members.',
  contactEmail: CONTACT_EMAIL,
  twitter: 'Twitter',
  discord: 'Discord',
  or: 'or',
  followUs: 'Follow Open Campus on',
  earnAllowlistSpot:
    'to find out more ways to earn your Open Campus Supply NFT.',
  AnswerBlockchainTrivia:
    'Can you answer these blockchain trivia questions before time runs out?',
  playAgainTomorrow: 'Increase your odds by playing again tomorrow',
  connectWallet: 'Connect Wallet',
  fund: 'Fund',
  mint: 'Mint',
  gameOnlyPlayDesktop: 'This game can only be played on a desktop.',
  gotIt: 'Got it',
  partners: 'Partners',
  tinytap: 'TinyTap',
  animocaBrands: 'Animoca Brands',
  animocaBrandsDescription:
    'A leader in digital entertainment and blockchain that is working to advance digital property rights across all Web3 pillars. Animoca Brands supports the delivery of digital property ownership to teachers and will bring their network of 400+ portfolios to Open Campus.',
  mocaverseLearnRealm: 'Mocaverse ‘Learn Realm’',
  theSandbox: 'The Sandbox',
  theSandboxDescription:
    'A virtual Metaverse where players can build, own, and monetize their gaming experiences offering a place for players to create virtual worlds and games collaboratively. Open Campus will build a dedicated EduLand in The Sandbox to showcase decentralized education.',
  gemsEducation: 'GEMS Education',
  hookedProtocol: 'Hooked Protocol',
  hookedProtocolDescription:
    'The pioneer in building an immersive “edutainment” network to onramp the next billion users into web3. Hooked Protocol will work with Open Campus to fix the education dilemma by enabling AI-powered immersive and social learning experiences.',
  highstreet: 'Highstreet',
  highstreetDescription:
    'A leader in the commerce-centered metaverse that aims to bridge physical assets to Web3. Open Campus will create a gateway to integrate real-world educational content into tokenized assets in Highstreet World.',
  whitepaper: 'Whitepaper',
  dao: 'DAO',
  CommunityLedEducationSystem: 'Community-Led Education System',
  OpenCampusDescription:
    'Open Campus is a community-led protocol that leverages blockchain technology and invites all to build the future of education.\nPutting the power of learning back in the hands of educators and the community.',
  explore: 'Explore —>',
  id: 'ID',
  enterEmail: 'Enter email',
  getNotified: 'Get notified',
  thanksForSubscribing: 'Thanks for subscribing ',
  writingThatDown: 'Writing that down',
  homePage: {
    eduChain: 'EDU Chain',
    openingTitle: 'The First L3 Blockchain Built for Education',
    openingSubTitle: 'Building the infrastructure to bring education on chain.',
    openingDescription:
      "EDU Chain is bringing the five trillion-dollar education industry to the blockchain. We're launching a vibrant Dapp ecosystem that reimagines what Learn-to-Earn means. This platform elegantly links learning experiences with earning opportunities, making every step of the journey trackable on the blockchain.",
    ocL2Btn: 'OC L3 White Paper',
    nodeSaleBtn: 'Node sale in Q2 2024',
    trustedAndSupported: 'Trusted and supported by',
    roadmap: {
      roadmap: 'Roadmap',
      nodeSale: 'Node Sale',
      nodeSaleDescription:
        'Own your stake in the future of education on-chain, become a Principal Node operator, and receive network rewards.',
      devGrants: 'Hackathons and Developer Grants',
      devGrantsDescription:
        'Get funded for building, launching and scaling consumer-ready products from the ground up — from infrastructure to development, concept to deployment.',
      mainnet: 'Mainnet',
      mainnetDescription:
        'The first L3 purpose built to bring education on chain and reimagine learn to earn.',
      applyDescription:
        'Build the future of education with us. Apply for a developer grant today.',
    },
  },
}
